export default __webpack_public_path__ + "static/logo-rotonde-cress-black-e0ca870c227633beea8ee844b33fd863.png";